export default "__VITE_ASSET__CEGwYw6l__"